import { DateTime } from "effect";

// Relative time is what a list is scanned for; the absolute date lives on the document page (or, on
// the pack/guide indexes, in the row's tooltip). Shared by every index that shows a "last updated".
//
// Counted in LOCAL CALENDAR DAYS, not 24-hour blocks: "today" has to mean today, so 23:00 yesterday
// reads "yesterday" rather than "today" and 01:00 today reads "today" rather than "1d ago".
const DAY_MS = 1000 * 60 * 60 * 24;
const startOfLocalDay = (ms: number): number => {
  const date = new Date(ms);
  date.setHours(0, 0, 0, 0);
  return date.getTime();
};
export const since = (at: DateTime.Utc): string => {
  const days = Math.round(
    (startOfLocalDay(Date.now()) - startOfLocalDay(DateTime.toEpochMillis(at))) / DAY_MS,
  );
  if (days <= 0) return "today";
  if (days === 1) return "yesterday";
  if (days < 30) return `${days}d ago`;
  if (days < 365) return `${Math.round(days / 30)}mo ago`;
  return `${(days / 365).toFixed(1)}y ago`;
};
